// Legacy reference values are uppercased; we display them in Title Case while
// keeping known acronyms intact (e.g. "GWIMOVE - POD" stays, "STORAGE LFD" → "Storage LFD").
const ACRONYMS = new Set([
  'GWI', 'IANA', 'FCFS', 'PPE', 'US', 'USA', 'LLC', 'INC', 'DC',
  'GWIMOVE', 'POD', 'LFD', 'EIR', 'BOL', 'IT', 'BD',
]);

export function titleCase(s: string): string {
  if (!s) return s;
  return s.toLowerCase().replace(/[a-z0-9]+/g, (w) => {
    const up = w.toUpperCase();
    return ACRONYMS.has(up) ? up : w.charAt(0).toUpperCase() + w.slice(1);
  });
}
